import { render } from "./B2bPagePendingsTask.vue?vue&type=template&id=3fb8afcd&scoped=true&lang=pug"
import script from "./B2bPagePendingsTask.vue?vue&type=script&lang=js"
export * from "./B2bPagePendingsTask.vue?vue&type=script&lang=js"

import "./B2bPagePendingsTask.vue?vue&type=style&index=0&id=3fb8afcd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb8afcd"]])

export default __exports__